import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData, postData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';
import { useParams } from "react-router-dom";
import { FaImage } from "react-icons/fa";
import { IoClose } from 'react-icons/io5';
import Modal from "react-modal";
import { FaRegTimesCircle } from "react-icons/fa";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "50%",
        maxWidth: "50%",
    },
};

function InventoryDetails() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const { id } = useParams();
    const [orderList, setOrderList] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetails, setOrderDetails] = useState("");
    const [productList, setProductList] = useState([]);
    const [errors, setErrors] = useState({});
    const [text, setText] = useState('');
    const [value] = useDebounce(text, 1000);
    const [inventoryQuantity, setInventoryQuantity] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const [formData, setFormData] = useState({
        visibleLable: false,
        file: [
            {
                fileType: "",
                file: ""
            }
        ],
    });

    useEffect(() => {
        // Call API with the order ID
        fetchOrderDetails(id);
    }, [id]);

    useEffect(() => {
        getInventoryQuantity();
    }, []);

    async function getInventoryQuantity() {

        let filterData = {
            productId: id,
            type: "viewAll",
        };
        setIsLoadingOn(true);
        const tempData = await postData(`inventory/getInventoryQuantity`, filterData);
        setIsLoadingOn(false);
        if (tempData?.statusCode === 200) {
            const records = tempData?.data;
            setInventoryQuantity(records);

            // setOrderDetails(records[0]);
            // setSelectedOrder(records[0])
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    async function fetchOrderDetails(id) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getInventoryItem?productId=${id}`);
        // const tempData = await res.json();
        setIsLoadingOn(false);
        // console.log("tempData++++", tempData)
        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;

            if (Array.isArray(records) && records.length > 0) {
                setOrderDetails(records[0]);
                setSelectedOrder(records[0]);
            } else {
                setOrderDetails(null);
                setSelectedOrder(null);
                console.warn("No records found.");
            }
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    async function getPurchaseOrder(typeValue) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getInventoryItem`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records;
            if (Array.isArray(records)) {
                setOrderList(records);
            } else {
                setOrderList([]);
            }
        } else {
            setOrderList([]); // ensure orderList is not undefined
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    // Debounced search
    useEffect(() => {
        getPurchaseOrder(value); // if empty string, returns all
    }, [value]);

    // const totals = productList.reduce(
    //     (acc, item) => {
    //         const qty = Number(item?.quantity) || 0;
    //         const rate = Number(item?.rate) || 0;
    //         const discount = Number(item?.discount) || 0;
    //         const itemTotal = qty * rate - discount;

    //         acc.totalQuantity += qty;
    //         acc.subTotal += qty * rate;
    //         acc.totalDiscount += discount;
    //         acc.total += itemTotal;

    //         return acc;
    //     },
    //     { totalQuantity: 0, subTotal: 0, totalDiscount: 0, total: 0 }
    // );

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        const maxFiles = 3;
        const maxSize = 5 * 1024 * 1024; // 5MB

        let newErrors = {};

        if (files.length > maxFiles) {
            newErrors.images = `Maximum ${maxFiles} images allowed.`;
        }

        const invalidSize = files.find((file) => file.size > maxSize);
        if (invalidSize) {
            newErrors.images = "Each image must be less than 5 MB.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors((prev) => ({ ...prev, ...newErrors }));
            setFormData((prev) => ({ ...prev, images: [] })); // clear images if invalid
        } else {
            setFormData((prev) => ({ ...prev, images: files }));
            setErrors((prev) => ({ ...prev, images: null }));
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const showmodal = () => {
        setIsOpen(true);
    }

    console.log("orderDetails", orderDetails)

    return (
        <div className="purchaseOrderDetails" style={{ backgroundColor: "#fff", marginLeft: "-20px" }}>
            {isLoadingOn ? <Loader /> : ""}
            <div className="row ordersec formsec purchaseform newItem">
                <div className="col-sm-3 lfsec pd0">
                    <div className="ps-3 pt-3 pb-3 d-flex justify-content-between">
                        <h5>Active Items</h5>
                        <Link to={'/inventory/new'}>
                            <button className="btn btn-primary mx-2">
                                + New
                            </button>
                        </Link>
                    </div>
                    {
                        orderList.map((item, index) => {
                            const isSelected = selectedOrder?.id === item?.id;

                            return <div
                                className={`lfheader d-flex ${isSelected ? 'selected' : ''}`}
                                key={index}
                                onClick={() => {
                                    setSelectedOrder(item);
                                }}
                            >
                                <div>
                                    {/* <input type="checkbox" /> */}
                                </div>
                                <Link to={`/inventoryDetails/${item.id}`} className="d-flex justify-content-between w-100">
                                    <div className="ms-3">
                                        <div className="hd">{item?.productName}</div>
                                        <div className="podate">{item?.sku}</div>
                                        <div className="orderStatus">{item?.status}</div>
                                    </div>
                                    <div className="ms-auto amount">
                                        Rs.{item?.sellingPrice ? Number(item.sellingPrice).toFixed(2) : '0.00'}
                                    </div>
                                </Link>
                            </div>

                        })
                    }
                </div>
                <div className="col-sm-9 rtsec pd0">
                    {orderDetails && (
                        <div className="ps-4 pt-3 pb-3 d-flex">
                            <h5>{orderDetails.productName}</h5>
                            <div className="ms-auto">
                                <Link to={'/inventory/items'}><IoClose size={24} style={{ cursor: "pointer", color: "#666" }} /></Link>
                            </div>
                        </div>
                    )}
                    <div className="scroll-y noscroll-x fill body scrollbox">
                        {orderDetails && (
                            <div className="row">
                                <div className="col-sm-8">
                                    <div className="itemInfo">
                                        <div className="row">
                                            <div className="col-sm-3 label">Item Type</div>
                                            <div className="col-sm-8 value">{orderDetails?.type}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">SKU</div>
                                            <div className="col-sm-8 value">{orderDetails?.sku}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Unit</div>
                                            <div className="col-sm-8 value">{orderDetails?.unit}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Dimensions</div>
                                            <div className="col-sm-8 value">{orderDetails?.dimensions}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Weight</div>
                                            <div className="col-sm-8 value">{orderDetails?.weight}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Created Source</div>
                                            <div className="col-sm-8 value">{orderDetails?.type}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Inventory Account</div>
                                            <div className="col-sm-8 value">{orderDetails?.inventoryAccount}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Inventory Valuation Method</div>
                                            <div className="col-sm-8 value">{orderDetails?.inventoryValuationMethod}</div>
                                        </div>
                                    </div>
                                    <div className="purchaseInfo mt-5">
                                        <h5>Purchase Information</h5>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Cost Price</div>
                                            <div className="col-sm-8 value">{orderDetails?.costPrice}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Purchase Account</div>
                                            <div className="col-sm-8 value">{orderDetails?.purchaseAccount}</div>
                                        </div>
                                    </div>
                                    <div className="purchaseInfo mt-5">
                                        <h5>Sales Information</h5>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Selling Price</div>
                                            <div className="col-sm-8 value">{orderDetails?.sellingPrice}</div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3 label">Sales Account</div>
                                            <div className="col-sm-8 value">{orderDetails?.sellingAccount}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="image-upload item-details-image">
                                        <div className="hv-centered w-100">
                                            <div><FaImage fontSize={40} /></div>
                                            <div className="font-small">
                                                <label className="text-muted drag-text">Drag image(s) here or</label>
                                                <br />
                                                <span className="text-blue cursor-pointer browseimg">Browse images</span>
                                            </div>
                                            <div>
                                                <span className="font-xs text-muted">&nbsp;You can add up to 3 images, each not exceeding 5 MB in size and 7000 X 7000 pixels resolution.</span>
                                            </div>
                                        </div>
                                        <span id="upload">
                                            <input
                                                multiple
                                                accept="image/gif,image/jpeg,image/png,image/bmp,image/jpg"
                                                className="upload ember-view form-control"
                                                name="file"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                        </span>
                                    </div>
                                    {
                                        inventoryQuantity.length > 0 && inventoryQuantity.some(item => item.quantity > 0) && (
                                            <div className="stockinfo">
                                                <div className="row font-weight-bold">
                                                    <div className="col-sm-9" style={{ fontSize: "14px", fontWeight: "bold" }}>Warehouse Name</div>
                                                    <div className="col-sm-3" style={{ fontSize: "14px", fontWeight: "bold" }}>Quantity</div>
                                                </div>
                                                {
                                                    inventoryQuantity.map((item, index) => (
                                                        <div className="row mt-1" key={index}>
                                                            <div className="col-sm-9">{item?.warehouseName}</div>
                                                            <div className="col-sm-3">{item?.quantity}</div>
                                                        </div>
                                                    ))
                                                }
                                                <button className="btn btn-primary viewallbtn" onClick={showmodal}>View All</button>
                                            </div>
                                        )
                                    }

                                    <div className="stockinfo">
                                        <h5>Opening Stock : 0.00</h5>
                                        <div className="accountstock mt-5">
                                            <h5>Accounting Stock </h5>
                                            <div className="row mt-4">
                                                <div className="col-sm-7 label">Stock on Hand :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-sm-7 label">Committed Stock :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-sm-7 label">Available for Sale :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                        </div>
                                        <div className="accountstock mt-5">
                                            <h5>Physical Stock </h5>
                                            <div className="row mt-4">
                                                <div className="col-sm-7 label">Stock on Hand :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-sm-7 label">Committed Stock :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-sm-7 label">Available for Sale :</div>
                                                <div className="col-sm-5 value">0.00</div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="mt-3">
                                            <div class="po-field d-flex flex-wrap">
                                                <div class="qty-summary-card">
                                                    <div class="font-xxlarge fw-light over-flow">
                                                        <span>0</span>
                                                        <span class="font-xxs fw-normal text-grey-light ps-2">Qty</span>
                                                    </div>
                                                    <div class="font-xxs">To be Shipped</div>
                                                </div>
                                                <div class="qty-summary-card">
                                                    <div class="font-xxlarge fw-light over-flow">
                                                        <span>0</span>
                                                        <span class="font-xxs fw-normal text-grey-light ps-2">Qty</span>
                                                    </div>
                                                    <div class="font-xxs">To be Received</div>
                                                </div>
                                                <div class="qty-summary-card">
                                                    <div class="font-xxlarge fw-light over-flow">
                                                        <span>0</span>
                                                        <span class="font-xxs fw-normal text-grey-light ps-2">Qty</span>
                                                    </div>
                                                    <div class="font-xxs">To be Invoiced</div>
                                                </div>
                                                <div class="qty-summary-card">
                                                    <div class="font-xxlarge fw-light over-flow">
                                                        <span>0</span>
                                                        <span class="font-xxs fw-normal text-grey-light ps-2">Qty</span>
                                                    </div>
                                                    <div class="font-xxs">To be Billed</div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="po-field">
                                            <h5 class="fw-light">
                                                <span class="text-dashed-underline" id="e140a65c-0920-4c56-a59f-5b6ca91e6b1e" tabindex="0" aria-describedby="f6b21874-78de-4ab6-9637-0339d8513273">
                                                    <span class="text-dashed-underline">Reorder Point</span>
                                                </span>
                                            </h5>
                                            <div>
                                                <span class="text-semibold font-large"></span>
                                            </div>
                                            <div class="alert alert-warning p-3 font-small m-0">You have to enable reorder notification before setting reorder point for items.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>


            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <button className="modalCloseBtn inventoryqtyclg" onClick={closeModal}>
                    <FaRegTimesCircle />
                </button>
                {isLoadingOn ? <Loader /> : ""}
                <div className="inventoryQuantity">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Product Name</th>
                                <th>Warehouse Name</th>
                                <th>Distributor Shop Name</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inventoryQuantity.map((item, index) => (
                                <tr key={index}>
                                    <td>{item?.productName}</td>
                                    <td>{item?.warehouseName}</td>
                                    <td>{item?.distributorShopname}</td>
                                    <td>{item?.quantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal>
        </div>
    );
}

export default InventoryDetails;
